import { render } from "./upgrade-setting.vue?vue&type=template&id=32d0e3b2&scoped=true&ts=true"
import script from "./upgrade-setting.vue?vue&type=script&lang=tsx"
export * from "./upgrade-setting.vue?vue&type=script&lang=tsx"

import "./upgrade-setting.vue?vue&type=style&index=0&id=32d0e3b2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d0e3b2"]])

export default __exports__